import React from 'react'
import UserTermsLayout from 'presentation/shared/layouts/UserTermsLayout'

const UserTerms = () => <UserTermsLayout />

export default UserTerms
